<ion-button class="button-icon-clear-rounded" style="position: absolute; z-index: 1; right: 0" (click)="openInternationalizationModal()">
  <ion-icon name="globe-outline" color="dark"></ion-icon>
</ion-button>
